import { Provider } from '@angular/core';
import {
  DictionaryEntry,
  DYNAMIC_CONFIG_TOKEN,
} from 'libs/platform/dynamic-components/src/lib/services/config-fetchers/fetch-config-from-code.service';

import { brooks } from './brooks';

const brooksConfigs: DictionaryEntry[] = [
  [
    'brooks:horizontal-scrollable-panel',
    [brooks.horizontalScrollablePanelBestPerformingArticles],
  ], // TODO: This injection token is here for not breaking configs referencing to 'horizontal-scrollable-panel'.
  [
    'brooks:horizontal-scrollable-panel-best-performing-articles',
    [brooks.horizontalScrollablePanelBestPerformingArticles],
  ],
  [
    'brooks:horizontal-scrollable-panel-bought-this-season',
    [brooks.horizontalScrollablePanelBoughtThisSeason],
  ],
];

export const brooksConfigsInjectionTokenProvider: Provider = {
  provide: DYNAMIC_CONFIG_TOKEN,
  useValue: brooksConfigs,
  multi: true,
};
